import React, { useState } from 'react';
import { Typography, Box, Grid, Card, CardContent } from '@mui/material';
import { useSpring, animated } from 'react-spring';
import { styled } from '@mui/system';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  backgroundColor: '#f5f5f5',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  '&:hover': {
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
}));

const HoverCard = ({ id, title, content, hovered, setHovered }) => {
  const hoverStyles = useSpring({
    transform: hovered === id ? 'rotateY(15deg)' : 'rotateY(0deg)',
    config: { tension: 300, friction: 10 },
  });

  return (
    <Grid item xs={12} sm={6} md={3} key={id}>
      <animated.div
        style={hoverStyles}
        onMouseEnter={() => setHovered(id)}
        onMouseLeave={() => setHovered(null)}
        className="card-container"
      >
        <StyledCard>
          <CardContent>
            <Typography variant="h6" component="h4">
              {title}
            </Typography>
            <Typography variant="body2" component="p">
              {content}
            </Typography>
          </CardContent>
        </StyledCard>
      </animated.div>
    </Grid>
  );
};

const KnowOurSchoolSection = () => {
  const [hovered, setHovered] = useState(null);

  const boxes = [
    { id: 1, title: 'Infraestrutura', content: 'Conheça nossas instalações altamente modernas e bem equipadas.' },
    { id: 2, title: 'Equipe Pedagógica', content: 'Nosso time é formado por profissionais altamente qualificados.' },
    { id: 3, title: 'Atividades', content: 'Explore as atividades que oferecem aprendizado além do currículo.' },
    { id: 4, title: 'Eventos e Projetos', content: 'Saiba mais sobre nossos eventos e projetos educacionais.' },
  ];

  return (
    <Box mb={6} mt={10} className="know-our-school-section">
      <Typography variant="h4" component="h3" gutterBottom align="left">
        Conheça Nossa Escola
      </Typography>
      <Typography variant="body1" component="p" align="left">
        Nossa escola oferece uma infraestrutura moderna, com laboratórios bem equipados, salas de aula confortáveis e uma equipe dedicada de profissionais. Venha nos visitar e veja como podemos contribuir para o futuro do seu filho.
      </Typography>
      <Grid container spacing={4} mt={4}>
        {boxes.map(({ id, title, content }) => (
          <HoverCard
            key={id}
            id={id}
            title={title}
            content={content}
            hovered={hovered}
            setHovered={setHovered}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default KnowOurSchoolSection;
